<!-- PVAL-26685: a lookup with more than one display column is a small table — a header of column
     names over one cell per column. Drawn even with no rows, so a search that has not answered yet
     still shows what it will offer. A single-column list (every static enum) keeps no header: the row
     IS the value, and naming it would buy nothing a reader of the values does not already know. -->
<div class="vp-head" *ngIf="multiColumn" aria-hidden="true">
  <span
    class="vp-cell vp-head-cell"
    *ngFor="let header of headers; let i = index"
    [style.flex]="cellFlex(i)"
    >{{ header }}</span
  >
</div>

<!-- A curated list that resolved to nothing still opens: "No values" is an answer, and a panel that
     refused to appear would read as a dead cell. -->
<div class="vp-empty" *ngIf="!rows.length">No values</div>

<div class="vp-rows" *ngIf="rows.length" role="listbox">
  <div
    class="vp-row"
    *ngFor="let row of rows"
    role="option"
    [attr.aria-selected]="row.selected"
    [class.vp-row-selected]="row.selected"
    [class.vp-row-clear]="row.clear"
    [class.vp-row-cells]="multiColumn && !row.clear"
    [attr.title]="row.title || null"
    (mousedown)="pick(row, $event)"
  >
    <ng-container *ngIf="multiColumn && !row.clear; else single">
      <span
        class="vp-cell"
        *ngFor="let cell of row.cells; let i = index"
        [style.flex]="cellFlex(i)"
        >{{ cell }}</span
      >
    </ng-container>
    <ng-template #single>{{ row.text }}</ng-template>
  </div>
</div>
